/** ログイン画面のパス */
const LOGIN_PATHS = ['/login', '/login/'];

/**
 * パス文字列がログイン画面のものかを判定する
 *
 * @param path route.path 等のパス文字列
 * @returns true: ログイン画面、false: その他
 */
const isLoginRoutePath = (path: string): boolean => LOGIN_PATHS.includes(path);

/**
 * パス文字列が荷役作業系画面（/work 配下）のものかを判定する
 *
 * @param path route.path 等のパス文字列
 * @returns true: 荷役作業系画面、false: その他
 */
const isWorkRoutePath = (path: string): boolean => path === '/work' || path.startsWith('/work/');

/**
 * ルートの種類に関する条件をリアクティブに提供するcomposable。
 */
export const useRouteConditions = () => {
  const route = useRoute();

  /** 現在表示中の画面がログイン画面か */
  const isLoginPage = computed(() => isLoginRoutePath(route.path));

  /** 現在表示中の画面が荷役作業系画面（/work 配下）か */
  const isWorkPage = computed(() => isWorkRoutePath(route.path));

  return {
    isLoginPage,
    isWorkPage,
  };
};
